import { useTradingSettings } from '@src/providers/AppConfigProvider';
import { FormControlSizes, MixpanelEvent, MixpanelEventProperty, Toggle, useMixpanel } from '@talos/kyoko';
import { useCallback } from 'react';

export function MobileShowAllDecimalsToggle() {
  const mixpanel = useMixpanel();
  const { showAllDecimalsInBlotters, setShowAllDecimalsInBlotters } = useTradingSettings();

  const handleShowAllDecimalsChange = useCallback(
    (value: boolean) => {
      mixpanel.track(MixpanelEvent.ShowAllDecimalsInBlotters, {
        [MixpanelEventProperty.Enabled]: value,
      });
      setShowAllDecimalsInBlotters(value);
    },
    [mixpanel, setShowAllDecimalsInBlotters]
  );

  return (
    <Toggle
      label="Show All Decimals"
      size={FormControlSizes.Default}
      checked={showAllDecimalsInBlotters}
      onChange={handleShowAllDecimalsChange}
      fullWidth
    />
  );
}
